import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import config from '../../../../../config';
import ConversationList from './ConversationList';
import SilverButton from "../../../../../components-new/buttons/SilverButton";
import SendIcon from "../../../../../assets/icons/SendIcon";
import colors from "../../../../../utils/Colors";
import Colors from "../../../../../utils/Colors";
import Popup from "../../../../../components-new/ui/Popup";
import Translate from "../../../../../components/Translate";
import {createNewInternalConversation, getNewConversationCandidates} from "../../../../../services/chat/api";
import LoadingComponent from "../../../../../components-new/ui/LoadingComponent";
import ContactAvatar from "../../../../../components-new/general/ContactAvatar";
import SearchInput from "../../../../../components-new/form/SearchInput";

const MemberConversationListManager = ({
                                           conversations,
                                           selectConversation,
                                           selectedConversation,
                                           insertConversation,
                                           addNotification
                                       }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isFetchingCandidates, setIsFetchingCandidates] = useState(false);
    const [candidates, setCandidates] = useState([]);
    const [search, setSearch] = useState("");

    const fetchCandidates = () => {
        setIsFetchingCandidates(true);
        getNewConversationCandidates().then(response => {
            setCandidates(response);
        })
            .finally(() => setIsFetchingCandidates(false))
    }

    const startNewConversation = (candidateId) => {
        createNewInternalConversation(candidateId).then(response => {
            insertConversation(response);
            selectConversation(response);
            setIsOpen(false);
        }).catch(e => {
            addNotification('error.failedCreateNewChat', config.notificationLevels.error)
        })
    }

    useEffect(() => {
        if (isOpen) {
            fetchCandidates();
        } else {
            setSearch("");
        }
    }, [isOpen]);

    const filteredCandidates = candidates.filter(candidate => {
        const fullName = (candidate.firstName + ' ' + candidate.lastName).toLowerCase();
        return fullName.includes(search.toLowerCase());
    });

    return (
        <React.Fragment>
            {/*
              * The same card padding the operator list is on. The list itself
              * used to carry 10px of its own through .ul-list, and that was
              * dropped when the two lists were lined up with the page inset -
              * which left the internal chats sitting against the panel edge.
              */}
            <div
                className="members flex-fill"
                style={{
                    overflowY: 'auto',
                    padding: 'var(--ds-spacing-md) var(--ds-spacing-xl)',
                    boxSizing: 'border-box',
                }}
            >
                <ConversationList
                    id="chat-incoming-list"
                    conversationList={conversations.filter(curConversation => curConversation.platform === config.platformsMap.company)}
                    contactsNameSpace={config.contactsNameSpaces.members}
                    selectConversation={selectConversation}
                    selectedConversation={selectedConversation}
                />
            </div>
            <div className="new-internal-chat" style={{padding: 'var(--ds-spacing-xl)', paddingTop: 'var(--ds-spacing-md)'}}>
                <Popup
                    trigger={
                        <SilverButton height={40}>
                            <SendIcon width={18} heigh={18} style={{color: colors.silverDark}} stroke="currentColor"/>
                            <span style={{marginLeft: '4px', color: colors.silverDark, fontWeight: 'bold'}}>
                                <Translate text={'newChat'}/>
                            </span>
                        </SilverButton>
                    }
                    direction={'top'}
                    panelAlign={{horizontal: 'left', vertical: ''}}
                    isOpen={isOpen}
                    onOpenChange={setIsOpen}
                    disabled={false}
                    style={{width: '100%'}}
                    panelStyle={{width: '100%'}}
                >
                    <div style={{
                        height: '300px',
                        overflowY: isFetchingCandidates ? 'hidden' : 'auto',
                    }}>
                        <div style={{
                            textAlign: 'center',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: colors.silverDark,
                            margin: '6px'
                        }}>
                            <Translate text='newChat'/>
                        </div>
                        {
                            isFetchingCandidates ?
                                <LoadingComponent/>
                                :
                                <div>
                                    <div style={{padding: '4px'}}>
                                        <SearchInput
                                            value={search}
                                            onChange={e => setSearch(e.target.value)}
                                            containerStyle={{
                                                width: '100%',
                                                marginBottom: '10px'
                                            }}
                                            style={{
                                                height: '36px',
                                            }}
                                        />
                                    </div>

                                    {filteredCandidates.length === 0 ?
                                        <div style={{
                                            textAlign: 'center',
                                            padding: '20px',
                                            color: Colors.silverBlueDark,
                                            height: candidates.length > 5 ? 'calc(100% - 68px)' : '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <Translate text={'noResultsFound'}/>
                                        </div>
                                        :
                                        <div>
                                            {filteredCandidates.map(candidate => (
                                                <div
                                                    key={candidate.id}
                                                    className='new-internal-chat-candidate'
                                                    onClick={() => startNewConversation(candidate.id)}
                                                >
                                                    <div style={{
                                                        display: 'flex',
                                                        gap: '10px',
                                                        alignItems: 'center',
                                                        fontSize: '16px'
                                                    }}>
                                                        <div style={{flexShrink: 0}}>
                                                            <ContactAvatar
                                                                contact={{
                                                                    firstName: candidate.firstName,
                                                                    lastName: candidate.lastName,
                                                                    thumbUrl: candidate.thumbUrl,
                                                                }}
                                                                variant="menu"
                                                                size={30}
                                                            />
                                                        </div>

                                                        <span>{candidate.firstName + ' ' + candidate.lastName}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </div>
                        }

                    </div>
                </Popup>
            </div>
        </React.Fragment>
    )
};

MemberConversationListManager.propTypes = {
    conversations: PropTypes.array.isRequired,
    selectConversation: PropTypes.func.isRequired,
    selectedConversation: PropTypes.object.isRequired,
};

export default MemberConversationListManager;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/MemberConversationListManager.jsx